<template>
    <client-page class="dark-theme">
        <!-- S: 탭 -->
        <template #contentsImmersive>
            <v-container>
                <education-tabs />
            </v-container>
        </template>
        <!-- E: 탭 -->

        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual title="교육 · 법률지원" src="/images/sub/sub-visual-education.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section title="법률 지원하기" class="page-section--sm page-section--first">
            <template slot="text">
                <p v-html="festa?.section2?.txt[0]?.replace(/\n/g, '<br/>')" />
            </template>
            <template>
                <table-primary class="mb--primary">
                    <table-primary-row v-for="(item, index) in festa.section3.table.list" :key="index">
                        <template #title>
                            <span v-html="item.title.replace(/\n/g, '<br />')" />
                        </template>
                        <template #text>
                            <p v-html="item.input.replace(/\n/g, '<br />')" />
                        </template>
                    </table-primary-row>
                </table-primary>
                <v-card outlined color="grey lighten-3" class="mb--md" data-aos="fade-up" data-aos-delay="100">
                    <div class="d-none d-md-block pa-md-30px pa-lg-60px">
                        <h4 class="tit tit--xs text-center mb-20px mb-md-40px">
                            진행 프로세스
                        </h4>
                        <v-img src="/images/sub/education/law/law-img.png" :aspect-ratio="1040 / 236" max-width="1040" class="mx-auto" />
                    </div>
                    <div class="pa-20px d-md-none">
                        <v-img src="/images/sub/education/law/law-img-mo.png" max-width="572" class="mx-auto" />
                    </div>
                </v-card>
                <v-row justify="center">
                    <v-col cols="auto">
                        <v-btn href="/file/유통데이터_법률자문_의뢰서.docx" download x-large outlined color="secondary" class="min-w-lg-210px justify-space-between">
                            신청서 내려받기(.docx)
                            <icon-down class="icon--size-small ml-12px" />
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn href="/file/유통데이터_법률자문_의뢰서.hwp" download x-large outlined color="secondary" class="min-w-lg-210px justify-space-between">
                            신청서 내려받기(.hwp)
                            <icon-down class="icon--size-small ml-12px" />
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </page-section>
        <page-section title="법률 정보 제공" text="스타트업이 알아야 할 법률 정보를 제공합니다." class="page-section--sm page-section--last">
            <table-primary class="mb--primary" data-aos="fade-up" data-aos-delay="100">
                <v-card v-for="application, index in applications" :key="index" tile @click="$router.push(`/education/law/` + application._id)">
                    <div class="pa-16px pa-md-24px">
                        <h4 class="tit tit--xs line-height-15 font-weight-regular text-truncate mb-4px mb-md-10px">
                            {{ application?.subject }}
                        </h4>
                        <p v-html="application?.content?.replace(/\n/g, '<br/>')" class="txt line-height-15 text-truncate-2 mb-12px mb-md-24px"></p>
                        <p class="txt txt--sm">
                            {{ $dayjs(application?.createdAt).format("YYYY-MM-DD") }} · 조회수 {{ application?.viewCount }}
                        </p>
                    </div>
                    <v-divider class="grye lighten-3"/>
                </v-card>
            </table-primary>
            <div class="v-pagination-wrap">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
            </div>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import EducationTabs from "@/components/client/education/education-tabs.vue";
import PageSection from "@/components/dumb/page-section.vue";
import UTabsSolid from "@/components/dumb/u-tabs-solid.vue";
import TablePrimary from "@/components/dumb/table-primary.vue";
import TablePrimaryRow from "@/components/dumb/table-primary-row.vue";
import IconDown from "@/components/client/icons/icon-down.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        EducationTabs,
        PageSection,
        TablePrimary,
        TablePrimaryRow,
        UTabsSolid,
        IconDown,
    },
    props: {},
    data() {
        return {
            festa: null,

            page: +this.$route.query.page || 1,
            pageCount: 0, // 페이징 분할 크기
            limit: 5, // n개 만큼 게시글 가져오기
            summary: { totalCount: 0 },

            applications: []
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { festa } = await api.v1.legal.festa.get();
            this.festa = festa;
            await this.search(false);
        },
        async search(routable = false) {
            // 페이징 or 필터 변경시 라우터 기록 -> 뒤로가기시 이전 라우터로 복귀
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, applications } = await api.v1.legal.applications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.applications = applications;
        },
    },
};
</script>
